import {Injectable}                           from '@angular/core';
import {MapActions, MapLoadFungiDetect}       from 'invoker-transport';
import {ImportStore}                          from '../import/import.store';
import {MapStore}                             from '../map/map.store';
import {ApSignalrService}                     from '../../ap-core/services/ap-signalr.service';
import {IGridStatus}                          from '../../ap-interface/interfaces/ap-grid-status.interface';
import {ApGuidUtil}                                 from '../../ap-utils';
import {SensorPlanBookType, SensorDataPlanBookInfo} from '../../types/sensor.types';
import ISensorFieldData = Data.Sensor.ISensorFieldData;

@Injectable({providedIn: 'root'})
export class ApSensorDataService {
  constructor(private _mapStateService: MapStore,
              private _backend: ApSignalrService,
              private _importStore: ImportStore) {
    this._backend.getListenerByActionType(MapActions.LOAD_FUNGI_DETECT_BY_DATASET)
      .subscribe((result) => {
        if (result.Error) {
          throw result.Error;
        }
        this._mapStateService.Layers.FungiDetectLayer.appendSource(result.Data);
        this._mapStateService.Layers.FungiDetectLayer.ZoomIn(500);
        this._importStore.finishLoadMapPreview();
      });
  }

  public loadByDataset(datasetId: string): void {
    this._importStore.startLoadMapPreview(datasetId);
    this._backend.send(new MapLoadFungiDetect([
      {Name: 'datasetId', Type: 'System.Guid', Value: datasetId}
    ]));
  }

  public getStatusSensorFieldData(sensorData: ISensorFieldData): IGridStatus {
    if (sensorData?.ValidForCampaignYear === true) {
      let description = 'Global__ApplMap_Can_Be_Created';
      const planBookInfo = this.getPlanBookInfoFromSensorFieldData(sensorData);
      if (!!planBookInfo) {
        if (planBookInfo.Type === SensorPlanBookType.NFertilizationPlanBook) {
          description = 'Global__NFertilization';
        } else if (planBookInfo.Type === SensorPlanBookType.PlanProtectionPlanBook) {
          description = 'Global__PlantProtection';
        }
      }
      return {
        state: 1,
        class: 'ap-status-green',
        description
      };
    }
    return {
      state: -1,
      class: 'ap-status-grey',
      description: ''
    };
  }

  public getPlanBookInfoFromSensorFieldData(sensorData: ISensorFieldData): SensorDataPlanBookInfo | undefined {
    if (!sensorData) {
      return undefined;
    }
    if (sensorData.NfPlanBookId != null && sensorData.NfPlanBookId !== ApGuidUtil.getEmptyGuid()) {
      return {
        PlanBookId: sensorData.NfPlanBookId,
        Type: SensorPlanBookType.NFertilizationPlanBook
      } as SensorDataPlanBookInfo;
    }
    if (sensorData.PpPlanBookId != null && sensorData.PpPlanBookId !== ApGuidUtil.getEmptyGuid()) {
      return {
        PlanBookId: sensorData.PpPlanBookId,
        Type: SensorPlanBookType.PlanProtectionPlanBook
      } as SensorDataPlanBookInfo;
    }
    return undefined;
  }
}
